export default __webpack_public_path__ + "static/media/qr_phaya_v2.3246341f.png";